import React from 'react';
import { cn } from '@/utils/tailwind-utils';

interface FooterDrawerDoneButtonProps {
  disabled?: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
}

const FooterDrawerDoneButton: React.FC<FooterDrawerDoneButtonProps> = ({ disabled, onClick, children }) => {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'footer-drawer-done-btn',
        disabled ? 'footer-drawer-done-btn--disabled' : 'footer-drawer-done-btn--active'
      )}
    >
      <span className="footer-drawer-done-label">{children}</span>
    </button>
  );
};

export default FooterDrawerDoneButton;
